import React, {useEffect, useMemo, useState} from "react";
import LogoSvg from "./logo.svg";
import LogoMobile from "./logoMobile_white.svg";
import Hamburg from "./hamBurger.svg";
import {NavLink, useLocation} from "react-router-dom";
import useWindowDimensions from "../../utils/Responsive";
import { CloseOutlined } from '@ant-design/icons';

export const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const { width } = useWindowDimensions();
  const toggle = () => {
      setToggleMenu(!toggleMenu);
  };
  const [isMobile, setIsMobile] = useState(false);
    const location = useLocation();
  useEffect(() => {
    setIsMobile(width <= 560);
    console.log('8 locaion ', location)
  }, [width]);

  const routeName = useMemo(() => {
      if(location.pathname){
          return location.pathname;
      }
  }, [location])
  return (
    <div className="nav-container">
      <div className="center-container">
        <div className="logo-container">
         <img src={width > 800 ? LogoSvg : LogoMobile} height={120} width={150} alt="sprintly" />
        </div>
          {(width > 800 || toggleMenu) && <div className="menu-container">
              <div onClick={toggle}>
                  <NavLink to="/" style={{textDecoration: "none"}}

                  >
                  <div className={
                      "menu-items" + (routeName == '/' ? " selected-nav" : " ")
                  }>Home</div>
              </NavLink>
              </div>
            <div onClick={toggle}>
                <NavLink to="/services" style={{textDecoration: "none"}}>
                    <div className={
                        "menu-items" + (routeName == '/services' ? " selected-nav" : " ")
                    }>Service</div>
                </NavLink>
            </div>
              {/*<div onClick={toggle}>*/}
              {/*<NavLink to="/#" style={{textDecoration: "none"}}>*/}
              {/*    <div className="menu-items">Our work</div>*/}
              {/*</NavLink>*/}
              {/*</div>*/}
              <div onClick={toggle}>
              <NavLink to="/about-us" style={{textDecoration: "none"}}>
                  <div className={
                      "menu-items" + (routeName == '/about-us' ? " selected-nav" : " ")
                  }>About US</div>
              </NavLink>
              </div>
              <div onClick={toggle}>
              <NavLink to="/contact-us" style={{textDecoration: "none"}}>
                  <div className={
                      "menu-items" + (routeName == '/contact-us' ? " selected-nav" : " ")
                  }>Contact US</div>
              </NavLink>
              </div>
          </div>}
         <button onClick={toggle}> {toggleMenu ? <CloseOutlined className="closebtn"/> : <img src={Hamburg}/>}</button>
      </div>

    </div>
  );
};
